import React from "react";
import Grid from "@material-ui/core/Grid";
import styles from "./DealerDiscountTooltip.module.scss";
import Clear from "@material-ui/icons/Clear";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import CheckCurrencyValue from "../../../../../utils/CheckCurrencyValue";
import HasPermissionTo from "../../../../../common/HasPermissionTo";

const StyledClear = withStyles({
  root: {
    color: "#102b4e",
  },
})(Clear);

const DealerDiscountTooltip = (props) => {
  return (
    <div data-testid={`vmTooltip_${props.index}`}>
      <button className={styles.exitButton}>
        <StyledClear
          onClick={() => {
            props.updateIndividualEditIndex(-1);
          }}
        />
      </button>
      <div className={styles.vmTitle}>
        <span>{props.t("DealerVehicles.dealerAdjustment")}</span>
      </div>
      <Grid container key={3} space={12} className={styles.toolTipTable}>
        <Grid item xs={12} className={styles.rowItemBold}>
          <span>{props.t("DealerVehicles.specAdj")}</span>
        </Grid>
        <Grid item xs={12} className={styles.rowItem}>
          {CheckCurrencyValue(props.currencySymbol, props.adjustment)}
        </Grid>
        <HasPermissionTo
          permissions={props.user.permissions.rolePermissions}
          perform={["vehiclePricing:write"]}
          condition={!props.user.readOnly}
          render={() => (
            <Grid item xs={12} className={styles.link}>
              <a onClick={() => props.toggleEditBox()}>
                {" "}
                <span>{props.t("DealerVehicles.edit")}</span>
              </a>
            </Grid>
          )}
        />
      </Grid>
      <Grid container key={3} space={12} className={styles.toolTipTable}>
        <Grid item xs={12} className={styles.rowItemBold}>
          <span>{props.t("DealerVehicles.fordRecAdj")}</span>
        </Grid>
        <Grid item xs={12} className={styles.rowItem}>
          {CheckCurrencyValue(
            props.currencySymbol,
            props.recommendedAdjustment
          )}
        </Grid>
        <HasPermissionTo
          permissions={props.user.permissions.rolePermissions}
          perform={["vehiclePricing:write"]}
          condition={!props.user.readOnly}
          render={() => (
            <Grid item xs={12} className={styles.link}>
              <a
                onClick={(e) => {
                  if (props.resetVehiclesRow) {
                    props.resetVehiclesRow(e, props.dataRow, props.index);
                  } else if (props.resetOptionsRow) {
                    props.resetOptionsRow(e, props.index);
                  }
                }}
              >
                <span>{props.t("DealerVehicles.apply")}</span>
              </a>
            </Grid>
          )}
        />
      </Grid>
    </div>
  );
};

export default withTranslation("emp")(DealerDiscountTooltip);
